import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule, MatInputModule } from '@angular/material';
import { NotificationIconComponent } from './notification-icon/notification-icon.component';
import { IndicatorComponent } from './indicator/indicator.component';
import { BusyModule } from 'tixif-ngx-busy';
import { TeaComponent } from './forms/tea/tea.component';

@NgModule({
  imports: [
    FormsModule,
    MatSelectModule,
    MatInputModule,
    CommonModule,
    BusyModule
  ],
  exports: [
    NotificationIconComponent,
    IndicatorComponent,
    BusyModule,
    TeaComponent
    ],
  declarations: [
    NotificationIconComponent,
    IndicatorComponent,
    TeaComponent
  ]
})
export class UiModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/ui/ui.module.ts